function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_952",
  transform: "translate(-362.498 132.741)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_953",
  transform: "translate(362.498 -132.741)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1526",
  d: "M128.66,120.345a2.342,2.342,0,0,1-.158-.52c-.025-.366-.007-.735-.007-1.127a3.815,3.815,0,0,1-3.37-3.354c-.343,0-.7,0-1.047,0a.718.718,0,0,1-.37-.047c-.1-.075-.224-.241-.207-.345a.419.419,0,0,1,.308-.255c.429-.03.861-.012,1.309-.012a3.787,3.787,0,0,1,3.378-3.377c0-.4.006-.8,0-1.207,0-.231.052-.424.311-.434s.343.188.347.411c.008.4,0,.809,0,1.228a3.8,3.8,0,0,1,3.354,3.377c.371,0,.751-.017,1.129.007a2.3,2.3,0,0,1,.52.158v.306a2.806,2.806,0,0,1-.554.183,3.894,3.894,0,0,1-.8,0c-.264-.023-.338.1-.387.333a3.6,3.6,0,0,1-2.814,2.917c-.143.038-.288.067-.444.1,0,.354.024.673-.008.986a3.946,3.946,0,0,1-.183.668Zm.161-8.335A2.95,2.95,0,0,0,125.829,115a3,3,0,0,0,2.917,3,3.035,3.035,0,0,0,3.059-2.981A2.983,2.983,0,0,0,128.821,112.01Z",
  transform: "translate(-123.498 -109.666)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1529",
  d: "M134.83,119.4a1.666,1.666,0,1,1-1.655-1.687A1.675,1.675,0,0,1,134.83,119.4Zm-.674-.014a.992.992,0,1,0-.989.986A.976.976,0,0,0,134.156,119.381Z",
  transform: "translate(-127.85 -114.041)",
  fill: "#fec22d"
})));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.656,
    height: 10.679,
    viewBox: "0 0 10.656 10.679",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.da9bb530.svg";
export { ForwardRef as ReactComponent };